import { Audio, Images, Text, Tweens } from "@abcya/abcya_phaser";
import FontKeys from "../FontKeys";
import Gator from "../game/Gator";
import Newspaper from "../game/Newspaper";
import gameData from "../gameData";
import TitleScene from "../scenes/TitleScene";
import UIAssetKeys from "../UIAssetKeys";

export default class Popup extends Phaser.GameObjects.Container
{
	constructor(scene, type, NavBar)
	{
		super(scene)

		this.NavBar = NavBar;
		this.type = type;

		this.bg = null;
		this.bgCont = null;

		this.shader = null;

		this.help = null;
		this.resume = null;
		this.menu = null;

		this.shotText = null;
		this.dodgeText = null;

		this.title = null;
		this.masker = null;

		this.gator = null;
		this.tail = null;
		this.torso = null;
		this.arm = null;

		this.newspaper = null;

		this.shader = this.scene.add.rectangle(0, 0, this.scene.scale.width, this.scene.scale.height, 0x000000, 1).setOrigin(0).setAlpha(0);
		this.shader.setInteractive();
	
		Tweens.addTween(this.shader, 500, {alpha: .65}, Phaser.Math.Easing.None);

		gameData.gamePaused = true;

		if(!gameData.mute) Audio.playOneShot("title_slime", this.scene);

		let gatorWord;
		if(this.type === "Paused") gatorWord = "Hold";
		if(this.type === "TimesUp") gatorWord = "Finished";
		if(this.type === "Score") gatorWord = "Success";
		if(this.type === "LevelComplete") gatorWord = "Victory";

		this.gator = new Gator(this.scene, "left", 1, gatorWord);
		this.scene.add.existing(this.gator);
		this.gator.setPosition(535, 500);

		this.bgCont = this.scene.add.container();
		this.bg = Images.addImage(0, 0, UIAssetKeys._popupBG, this.bgCont);

		this.tail = Images.addImage(0, 0, UIAssetKeys._GatorTail, this.bgCont).setOrigin(0);
		this.masker = Images.addImage(0, 0, UIAssetKeys._popupMask, this.bgCont).setOrigin(0);
		this.title = Images.addImage(0, 0, this.type, this.bgCont);
		this.arm = Images.addImage(0,0, UIAssetKeys._GatorArmRight, this.bgCont);

		this.arm.alpha = 0;
		this.tail.alpha = 0;
		this.gator.alpha = 0;
		this.masker.alpha = 0;

		this.arm.scaleY = 0;
		this.bgCont.setScale(0, 0);
		if(this.type === "Score" || this.type === "TimesUp") this.title.setScale(.8, .8);

		this.arm.setOrigin(1, .1);
		this.tail.setOrigin(.9, .4);
		this.title.setOrigin(.5, .5);
		this.bg.setOrigin(.5, .5);

		this.title.setPosition(0, -70);
		if(this.type== "Score")
		{
			this.title.scale = 0.6;
		}
		this.arm.setPosition(150, -156);

		this.tail.setPosition(-100, -78);
		this.masker.setPosition(-255, -185);
		this.bgCont.setPosition(this.scene.scale.width/2, this.scene.scale.height/2);

		Tweens.addTween(this.bgCont, 1000, {scale: 1}, Phaser.Math.Easing.Back.Out, ()=>this.showGator());

		this.enableButtons();

		this.arm.alpha = 1;
		this.tail.alpha = 1;
		this.gator.alpha = 1;
		this.masker.alpha = 1;

		this.tail.angle = -220;
		this.arm.angle = -5;

		Tweens.addTween(this.gator, 1000, {y: 200}, Phaser.Math.Easing.Quadratic.Out);
		Tweens.addTween(this.arm, 500, {scaleY: 1}, Phaser.Math.Easing.Quadratic.Out);
		Tweens.addTween(this.tail, 1000, {angle: 0, x:-120, y:-177}, Phaser.Math.Easing.Quadratic.Out);

		if(this.type === "Paused") {
			this.resume = Images.addImage(this.bg.width/6,  75, UIAssetKeys._ResumeButton, this.bgCont).setOrigin(0);
			this.menu = Images.addImage(-this.bg.width/6,  75, UIAssetKeys._HomeBTN, this.bgCont).setOrigin(0);
		} else if(this.type === "TimesUp") {
			this.resume = Images.addImage(this.bg.width/6,  75, UIAssetKeys._ReplayBTN, this.bgCont).setOrigin(0);
			this.menu = Images.addImage(-this.bg.width/6,  75, UIAssetKeys._HomeBTN, this.bgCont).setOrigin(0);
		} else {
			this.resume = Images.addImage(this.bg.width/6,  95, UIAssetKeys._NextBTN, this.bgCont).setOrigin(0);
			this.menu = Images.addImage(-this.bg.width/6,  95, UIAssetKeys._HomeBTN, this.bgCont).setOrigin(0);
		}

		this.resume.setScale(.8, .8);
		this.menu.setScale(.8, .8);
		this.resume.setOrigin(.5, .5);
		this.menu.setOrigin(.5, .5);

		if(this.type== "Score")
		{
			console.log("showing score")
			// add the score text
			this.correctScore = Text.addText(-157,0, 40, 0x1D9099,FontKeys._ostrich_sansheavy, "CORRECT ANSWERS: " + gameData.correctAnswers,this.bgCont, false).setOrigin(0);
			this.incorrectScore = Text.addText(-180,50, 40, 0x1D9099,FontKeys._ostrich_sansheavy, "INCORRECT ANSWERS: " + gameData.incorrectAnswers,this.bgCont, false).setOrigin(0);
			this.resume.y = 300;
			this.menu.y = 300;
		}
	}

	enableButtons(){
		//console.log("enabling buttons");
		if(this.menu)
		{
			this.menu.setInteractive();
			this.menu.removeListener('pointerup');
		}
		if(this.resume)
		{
			this.resume.setInteractive();
			this.resume.removeListener('pointerup');
		}

		if(this.type === "Paused") {
			if(this.menu)this.menu.once('pointerup', this.goHome, this);
			if(this.resume)this.resume.once('pointerup', this.resumeGame, this);
		} else if(this.type === "Score"){
			if(this.menu)this.menu.once('pointerup', this.goHome, this)
			if(this.resume)this.resume.once('pointerup', this.goEnd, this);
		}
		else {
			if(this.menu)this.menu.once('pointerup', this.goHome, this);
			if(this.resume)this.resume.once('pointerup', this.reset, this);
		}
	};

	goHome(){
		if(!gameData.mute) Audio.playOneShot("gator_pop", this.scene);

		this.scene.sound.stopAll();

		this.scene.scene.start(TitleScene.KEY);
	};

	resumeGame(){
		if(!gameData.mute) Audio.playOneShot("gator_pop", this.scene);

		this.cleanUp();

		this.NavBar.resumeGame();
	};

	goEnd(){
		if(!gameData.mute) Audio.playOneShot("gator_pop", this.scene);

		this.menu.inputEnabled = false;
		this.resume.inputEnabled = false;

		this.scene.tweens.killAll();
		this.scene.sound.stopAll();

		this.newspaper = new Newspaper(this.scene, "end", this);
		this.scene.add.existing(this.newspaper);
	};

	reset(){
		if(!gameData.mute) Audio.playOneShot("gator_pop", this.scene);

		//this.cleanUp();

		//game.tweens.removeAll();
		this.scene.tweens.killAll();
		this.scene.sound.stopAll();

		if(this.scene.timer) {
			this.scene.time.events.remove(this.NavBar.timer);
			this.scene.timer = null;
		}

		this.scene.scene.start("PlayScene");
	};

	cleanUp(){

		if(this.menu)this.menu.disableInteractive();
		if(this.resume)this.resume.disableInteractive();

		//game.tweens.remove(this.arm);

		this.shader.destroy();
		this.gator.cleanUp();
		this.gator.destroy();
		this.tail.destroy();
		this.arm.destroy();
		this.tail.destroy();
		this.bg.destroy();
		this.menu.destroy();
		this.masker.destroy();
		if(this.resume) this.resume.destroy();
		this.title.destroy();
		if(this.newspaper) this.newspaper.destroy();
		this.correctScore?.destroy();
		this.incorrectScore?.destroy();

		this.bgCont.destroy();

		gameData.gamePaused = false;
	};

	showGator(){
		//console.log("NEXT AUDIO", this.sounds);
		this.enableButtons();

		this.arm.alpha = 1;
		this.tail.alpha = 1;
		this.gator.alpha = 1;
		this.masker.alpha = 1;

		this.tail.angle = -220;
		this.arm.angle = -5;

		Tweens.addTween(this.gator, 1000, {y:200}, Phaser.Math.Easing.Quadratic.Out);
		Tweens.addTween(this.arm, 500, {scaleY:1}, Phaser.Math.Easing.Quadratic.Out);
		Tweens.addTween(this.tail, 1000, {angle:0, x:-120, y:-177}, Phaser.Math.Easing.Quadratic.Out);
		Tweens.addTween(this.arm, 2000, {angle:10, loop: 80, yoyo: true, delay: 500}, Phaser.Math.Easing.Quadratic.InOut);
	}
}